import { Reducer } from "redux";

import { AuthorizationTypeMasterResponse } from "../models/Api/Master";
import { AuthorizationTypeDispatchTypes } from "../models/DispatchTypes/Master";
import { AuthorizationTypeMasterActionDispatchTypes } from "../constants/Master";
import { setLocalStorageData } from "../utils";

export const initialState: AuthorizationTypeMasterResponse = {
  loading: false,
  response: [],
};

const AuthorizationTypeMasterReducer: Reducer<
  AuthorizationTypeMasterResponse,
  AuthorizationTypeDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case AuthorizationTypeMasterActionDispatchTypes.GET_AUTHORIZATION_TYPE_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case AuthorizationTypeMasterActionDispatchTypes.GET_AUTHORIZATION_TYPE_SUCCESS: {
      setLocalStorageData(
        AuthorizationTypeMasterActionDispatchTypes.GET_AUTHORIZATION_TYPE_SUCCESS,
        action.response
      );
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case AuthorizationTypeMasterActionDispatchTypes.GET_AUTHORIZATION_TYPE_ERROR: {
      return initialState;
    }
  }
  return state;
};

export default AuthorizationTypeMasterReducer;
